import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TagClient } from '@app-services/api/clients/tag.client';
import { EmailTagClient } from '@app-services/api/clients/email-tag.client';
import { ChangedTags, TagContract } from '@app-types/api/tag';
import { EmailContract, EmailListItemContract } from '@app-types/api/email';
import { AddTagsDialogComponent } from '@app-components/common/add-tags-dialog/add-tags-dialog.component';
import { TagType } from '@app-types/enums/tags';

@Component({
  selector: 'app-email-add-tags-dialog',
  templateUrl: './email-add-tags-dialog.component.html',
  imports: [AddTagsDialogComponent],
})
export class EmailAddTagsDialogComponent {
  @Input() public emailsForTags!: {
    emails: EmailListItemContract[] | EmailContract[];
    ids: number[];
    mailAccountId?: number;
  };
  @Input() public isDrawer = true;
  @Output() submitEventEmitter = new EventEmitter<ChangedTags>();
  @Output() public closeEventEmitter = new EventEmitter<void>();

  constructor(
    private tagClient: TagClient,
    private emailTagClient: EmailTagClient
  ) {}

  get initialTags(): TagContract[] {
    const e = this.emailsForTags;
    if (!e?.emails?.length) return [];
    return e.emails.length === 1 ? [...(e.emails[0]?.tags ?? [])] : [];
  }

  loadTags = async (search: string | null = null): Promise<TagContract[]> => {
    if (!this.emailsForTags.mailAccountId) return [];
    const response = await this.tagClient.searchTagsForSelect(
      this.emailsForTags.mailAccountId,
      TagType.Email,
      search
    );
    return response.data;
  };

  insertTag = async (tag: string, color: string): Promise<TagContract> => {
    const requestData = {
      mailAccountId: this.emailsForTags.mailAccountId ?? 0,
      tag,
      color,
      type: TagType.Email,
    };
    await this.tagClient.insert(requestData);
    return { ...requestData, tagId: Date.now() };
  };

  saveTags = async (selectedTags: TagContract[]): Promise<void> => {
    await this.emailTagClient.saveTags({
      emailsId: this.emailsForTags.ids,
      tags: selectedTags.map(el => el.tag),
    });
    this.submitEventEmitter.emit({
      tags: selectedTags,
      ids: this.emailsForTags.ids,
    });
  };
}
